/* unplugin-vue-components disabled */import script from "./doList.vue?vue&type=script&setup=true&lang=js"
export * from "./doList.vue?vue&type=script&setup=true&lang=js"

import "./doList.vue?vue&type=style&index=0&id=5439c5a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5439c5a0"]])

export default __exports__